import type { HttpErrorInfo } from "./types";

let _logHttpError: ((info: HttpErrorInfo) => void) | undefined;
let _logError: ((error: Error, context?: Record<string, unknown>) => void) | undefined;
let _logInfo: ((message: string, context?: Record<string, unknown>) => void) | undefined;
let _logWarning: ((message: string, context?: Record<string, unknown>) => void) | undefined;

if (typeof window !== "undefined") {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const dd = require("./DatadogService");
    _logHttpError = dd.logHttpError;
    _logError = dd.logError;
    _logInfo = dd.logInfo;
    _logWarning = dd.logWarning;
  } catch {
    // Server bundle — browser-only module not available
  }
}

export const safeLogHttpError = (errorInfo: HttpErrorInfo): void => {
  if (_logHttpError) {
    _logHttpError(errorInfo);
    return;
  }
  console.error("[HTTP Error (server)]", errorInfo.message, errorInfo.endpoint);
};

export const safeLogError = (error: Error, context?: Record<string, unknown>): void => {
  if (_logError) {
    _logError(error, context);
    return;
  }
  console.error("[Server Error]", error.message, context);
};

export const safeLogInfo = (message: string, context?: Record<string, unknown>): void => {
  if (_logInfo) {
    _logInfo(message, context);
    return;
  }
  console.info("[Server Info]", message, context);
};

export const safeLogWarning = (message: string, context?: Record<string, unknown>): void => {
  if (_logWarning) {
    _logWarning(message, context);
    return;
  }
  console.warn("[Server Warning]", message, context);
};
